export const Footer = () => {
  return (
    <footer className="bg-brand-primary text-brand-bg" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-8 w-8 rounded-full bg-brand-bg/10 flex items-center justify-center">
                <span className="h-3 w-3 rounded-full bg-brand-secondary" />
              </span>
              <span className="font-display text-xl">NeuroNest</span>
            </div>
            <p className="mt-5 text-brand-bg/70 max-w-xs leading-relaxed">
              Growth &amp; Development Clinic — nurturing minds, empowering futures.
              A warm, evidence-based ABA clinic in Ahmednagar.
            </p>
          </div>

          <div>
            <p className="text-sm uppercase tracking-[0.2em] text-brand-bg/50 mb-5">Reach us</p>
            <ul className="space-y-3 text-brand-bg/85">
              <li><a href="tel:+919622847390" className="hover:text-brand-secondary transition-colors">+91 96228 47390</a></li>
              <li><a href="mailto:neuronest.rs@gmail.com" className="hover:text-brand-secondary transition-colors">neuronest.rs@gmail.com</a></li>
              <li>90 Feet Road, Ahmednagar</li>
              <li>Mon–Fri · 11:00 am – 6:00 pm</li>
            </ul>
          </div>

          <div>
            <p className="text-sm uppercase tracking-[0.2em] text-brand-bg/50 mb-5">Explore</p>
            <ul className="space-y-3 text-brand-bg/85">
              <li><a href="#approach" className="hover:text-brand-secondary transition-colors">Our approach</a></li>
              <li><a href="#services" className="hover:text-brand-secondary transition-colors">Services</a></li>
              <li><a href="#outcomes" className="hover:text-brand-secondary transition-colors">Why choose us</a></li>
              <li><a href="#contact" className="hover:text-brand-secondary transition-colors">Book a visit</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-bg/15">
          <p className="font-display font-light text-6xl sm:text-8xl md:text-[9rem] leading-none tracking-tight text-brand-bg/90">
            NeuroNest
          </p>
          <p className="mt-8 text-sm text-brand-bg/50">
            © {new Date().getFullYear()} NeuroNest ABA Clinic. All rights reserved.
            <a href="/inbox" data-testid="footer-staff-login" className="ml-3 underline decoration-brand-bg/30 hover:text-brand-secondary transition-colors">Staff login</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
